















































import {Component, Vue} from "vue-property-decorator";
import {DeliousApiUtil} from "@/_common/api/utils/delious_api_utils";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import ItemsStore from "@/_common/api/store/modules/ItemsStore";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import MainItem from "@/pages/ItemManagementPage/ItemDetail/MainItem.vue";
import CondimentGroup from "@/pages/ItemManagementPage/ItemDetail/CondimentGroup.vue";
import ThemeItem from "@/pages/ItemManagementPage/ItemDetail/ThemeItem.vue";
import CondimentGroupsStore from "@/_common/api/store/modules/CondimentGroupsStore";
import ThemeItemVariablesStore from "@/store/modules/ThemeItemVariablesStore";
import CategoryItemsStore from "@/_common/api/store/modules/CategoryItemsStore";

@Component({
    components: {
        ThemeItem,
        MainItem,
        CondimentGroup,
        DialogButtons,
    }
})
export default class ItemDetail extends Vue {
    get deliousItem(): Delious.Item {
        return DeliousItemsStore.itemById[Number(this.$route.params.itemId)] as Delious.Item || {};
    }

    get deliousCondimentGroups(): Delious.CondimentGroup[] {
        return DeliousApiUtil.itemToCondimentGroups(this.deliousItem);
    }

    get dirty() {
        return ItemsStore.dirty || ThemeItemVariablesStore.dirty || CondimentGroupsStore.dirty;
    }

    created() {
        const itemId: number = Number(this.$route.params.itemId);
        CategoryItemsStore.addGroupItems(itemId);
    }

    private onClickCancel() {
        ItemsStore.cancelEdit();
        ThemeItemVariablesStore.cancelEdit();
        CondimentGroupsStore.cancelEdit();
        this.$emit("cancel");
    }

    private onClickUpdate() {
        ItemsStore.applyEdit();
        ThemeItemVariablesStore.applyEdit();
        CondimentGroupsStore.applyEdit();
        this.$emit("update");
    }
}
